import { AUTH_SUCCESS, AUTH_LOGOUT, AUTH_FAIL, AUTH_START, SET_AUTH_REDIRECT_PATH } from '../../store/actions/actionTypes';

const initialState = {
	token: null,
	username: null,
	error: null,
	loading: false,
	authRedirectPath: '/unitEconomics',
};

const authStart = (state, action) => {
	return {
		...state,
		error: null,
		loading: true,
	};
};

const authSuccess = (state, action) => {
	return {
		...state,
		token: action.token,
		username: action.username,
		error: null,
		loading: false,
	};
};

const authFail = (state, action) => {
	return {
		...state,
		error: action.error,
		loading: false,
	};
};

const authLogout = (state, action) => {
	return {
		...state,
		token: null,
		username: null,
	};
};

const setAuthRedirectPath = (state, action) => {
	return {
		...state,
		authRedirectPath: action.path,
	};
};

const authReducer = (state = initialState, action) => {
	switch (action.type) {
		case AUTH_START:
			return authStart(state, action);
		case AUTH_SUCCESS:
			return authSuccess(state, action);
		case AUTH_FAIL:
			return authFail(state, action);
		case AUTH_LOGOUT:
			return authLogout(state, action);
		case SET_AUTH_REDIRECT_PATH:
			return setAuthRedirectPath(state, action);
		default:
			return state;
	}
};

export default authReducer;
